import { IconProps } from "./types";

export const IconlyWallet = ({
  size = 24,
  color = "currentColor",
}: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.9999 14.406H17.1928C15.7946 14.406 14.6621 13.2725 14.6621 11.8744C14.6621 10.4772 15.7946 9.34375 17.1928 9.34375H20.9999"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9966 11.8185H16.9936"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9358 3.6875H16.0639C18.7901 3.6875 20.9997 5.89708 20.9997 8.6233V15.3727C20.9997 18.0989 18.7901 20.3085 16.0639 20.3085H7.9358C5.20958 20.3085 3 18.0989 3 15.3727V8.6233C3 5.89708 5.20958 3.6875 7.9358 3.6875Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.2666 7.95913H12.3454"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
